export const INIT = "INIT";
export function initSettings(data) {
    return { type: INIT, data }
};



// WEBPACK FOOTER //
// ./src/services/store/reducers/settings/actions.js